import React, {Fragment} from "react";
import PropTypes from "prop-types";

function DashboardHeader(props) {
  const {name} = props;

  return (
    <Fragment>
      <h1 className="roboto-bold" data-cy="dashboardHeader">
        {name}
      </h1>
    </Fragment>
  );
}

DashboardHeader.propTypes = {
  name: PropTypes.string.isRequired,
};

export default DashboardHeader;
